import { UserType } from "@mcleod/core";
import { DataSource } from "@mcleod/components";
import { AutogenLayoutUserTableCarrier } from "./autogen/AutogenLayoutUserTableCarrier";
import { UserTableController  } from "./UserTableController";
import { UserTableLayout } from "./UserTableLayout";

export class UserTableCarrier extends AutogenLayoutUserTableCarrier implements UserTableLayout {
    public getSourceUsers(): DataSource {
        return this.sourceUserSettings;
    }

    public getUserType(): UserType {
        return UserType.CARRIER;
    }

    override onLoad(): void | Promise<void> {
        new UserTableController(this);
    }
}
